// extracted by mini-css-extract-plugin
export default {"headerRightHalfContainer":"ProductCodes_headerRightHalfContainer__Xezpl","warningMessage":"ProductCodes_warningMessage__T4kGx"};